require('./insuranceRequestWizardStep1.scss');
require('./insuranceRequestWizardStep1.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;
// @ components
const InsuranceRequestWizardBenefits = require('./insuranceRequestWizardBenefits');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKMessage } = require('commonsComponents/OKMessage');

class InsuranceRequestWizardStep1 extends React.Component {
    buildBenefits() {
        return this.benefitsItems().map((arrayItems, key) => {
            const [firstItem, secondItem] = arrayItems;

            return (
                <div key={key} className="row">
                    <InsuranceRequestWizardBenefits
                        key={`bullet-${firstItem.id}`}
                        icon={firstItem.icon}
                        title={firstItem.title}
                        description={firstItem.description}
                    />
                    {secondItem &&
                        <InsuranceRequestWizardBenefits
                            key={`bullet-${secondItem.id}`}
                            icon={secondItem.icon}
                            title={secondItem.title}
                            description={secondItem.description}
                        />
                    }
                </div>
            );
        });
    }

    buildPoeditorTerm(term, existTermCC = false) {
        const { isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHome';
        let poeditorItem = isRelated
            ? <FormattedText value={`${poeditorPrefix}Related-${poeditorPrefix}Related_${term}`} />
            : <FormattedText value={`${poeditorPrefix}-${term}`} />;

        if (__CONTACT_CENTER__ && existTermCC) {
            poeditorItem = isRelated
                ? <FormattedText value={`${poeditorPrefix}CC-${poeditorPrefix}CC_${term}CCRelated`} />
                : <FormattedText value={`${poeditorPrefix}CC-${poeditorPrefix}CC_${term}CC`} />;
        }
        return poeditorItem;

    }

    benefitsItems() {
        return [
            [
                {
                    id: 'easyContract',
                    icon: 'icon icon-estrategia',
                    title: this.buildPoeditorTerm('step1EasyContract'),
                    description: this.buildPoeditorTerm('step1ContractText'),
                },
                {
                    id: 'immediate',
                    icon: 'icon icon-asistencia',
                    title: this.buildPoeditorTerm('step1Immediate'),
                    description: this.buildPoeditorTerm('step1ImmediateText'),
                }
            ],
            [
                {
                    id: 'payAsYouWant',
                    icon: 'icon icon-cerrajero',
                    title: this.buildPoeditorTerm('step1PayAsYouWant'),
                    description: this.buildPoeditorTerm('step1PayAsYouWantText'),
                },
                {
                    id: 'flexibility',
                    icon: 'icon icon-manitas',
                    title: this.buildPoeditorTerm('step1Flexibility'),
                    description: this.buildPoeditorTerm('step1FlexibilityText'),
                }
            ]
        ];
    }

    buildContactCenterMandatoryReading() {
        const { isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHomeCC';

        const mandatoryReadingStep1 = isRelated
            ? `${poeditorPrefix}-${poeditorPrefix}_step1ListItem1CCRelated`
            : `${poeditorPrefix}-${poeditorPrefix}_step1ListItem1CC`;

        return __CONTACT_CENTER__ ?
            (<BlockInfo extraClass="home-insurance-step-product__cc-info">
                <FormattedText value={mandatoryReadingStep1} />
            </BlockInfo>) : null;
    }

    buildDisclaimer() {
        return __CONTACT_CENTER__ ? 
            (<ul className="home-insurance-step-product__bullets-list">
                <li className="home-insurance-step-product__bullets-item">{this.buildPoeditorTerm('step1ListItem2', true)}</li>
                <li className="home-insurance-step-product__bullets-item">{this.buildPoeditorTerm('step1ListItem3', true)}</li>
            </ul>):
            (<OKMessage>
                <ul className="home-insurance-step-product__bullets-list">
                    <li className="home-insurance-step-product__bullets-item">{this.buildPoeditorTerm('step1ListItem1')}</li>
                    <li className="home-insurance-step-product__bullets-item">{this.buildPoeditorTerm('step1ListItem2', true)}</li>
                    <li className="home-insurance-step-product__bullets-item">{this.buildPoeditorTerm('step1ListItem3', true)}</li>
                </ul>
            </OKMessage>);
    }

    render() {
        const benefits = this.buildBenefits();
        return (
            <section className="home-insurance-step-product">
                <div className="row">
                    <div className="col-xs-12 home-insurance-step-product__title">
                        {this.buildPoeditorTerm('step1Title')}
                    </div>
                    <div className="col-xs-12 home-insurance-step-product__subtitle">
                        {this.buildPoeditorTerm('step1Subtitle')}
                    </div>
                </div>
                {this.buildContactCenterMandatoryReading()}
                <div className="row home-insurance-step-product__items-container">
                    {benefits}
                </div>
                <div className="row home-insurance-step-product__bullets">
                    {this.buildDisclaimer()}
                </div>
            </section>
        );
    }
}


InsuranceRequestWizardStep1.propTypes = {
    isRelated: PropTypes.bool,
};

InsuranceRequestWizardStep1.defaultProps = {
    isRelated: false,
};

module.exports = InsuranceRequestWizardStep1;
